import React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import QRCode from "react-qr-code";
import toast from "react-hot-toast";
import { Copy, ExternalLink } from "lucide-react";

import { sucessLogo } from "../../../assets/images";
import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../../components/ui/dialog";
import { APP_SINGLE_BUSINESS_URL } from "../../../constant";

type Props = {
  reference: string | null;
  onOpenChange: (open: boolean) => void;
};

const PaymentSuccessDialog = ({ reference, onOpenChange }: Props) => {
  if (!reference) return null;
  const link = `${APP_SINGLE_BUSINESS_URL}/${reference}`;

  return (
    <Dialog open={!!reference} onOpenChange={onOpenChange}>
      <DialogContent className="font-manrope mds:max-w-[440px]">
        <DialogHeader className="items-center text-center">
          <img src={sucessLogo} alt="" className="size-[110px]" />
          <DialogTitle className="font-sora text-[18px]">
            Payment page created
          </DialogTitle>
          <DialogDescription>
            Share the link or QR code with your customers to start collecting
            payments.
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col items-center gap-3">
          <div className="rounded-xl border bg-white p-3">
            <QRCode value={link} size={140} />
          </div>
          <p className="break-all text-center text-[12px] font-medium text-muted-foreground">
            {link}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-2 pt-2">
          <CopyToClipboard
            text={link}
            onCopy={() => toast.success("Payment link copied")}
          >
            <Button variant="outline" className="h-11 gap-2 rounded-xl bg-background">
              <Copy className="size-4" />
              Copy link
            </Button>
          </CopyToClipboard>
          <Button
            onClick={() => window.open(link, "_blank")}
            className="h-11 gap-2 rounded-xl"
          >
            <ExternalLink className="size-4" />
            Visit page
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentSuccessDialog;
